<!--
 * @Author: DY
 * @Date: 2021-05-12 17:58:28
 * @LastEditTime: 2022-11-02 16:10:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\matchingApproval\index.vue
-->
<template>
    <div class="matchingApproval">
        <v-touch @swiperight="swiperright" class="wrapper">
            <van-nav-bar
                title=""
                left-text="应用"
                left-arrow
                @click-left="onClickLeft"
            >
                <template #title>
                    <div
                        :class="{'active': listType == 'db'}"
                        @click="listSwitch('db')"
                    >
                        待审批
                    </div>
                    <div
                        :class="{'active': listType == 'yb'}"
                        @click="listSwitch('yb')"
                    >
                        已审批
                    </div>
                </template>
            </van-nav-bar>
            <section>
                <van-search v-model="value" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        :finished="finished"
                        finished-text="没有更多了!"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <template v-for="(item,index) in listData">
                                <li :key="index" :class="{'Associated': item.mixture_status == 1,'Uncorrelated': item.mixture_status == 0}">
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <span class="headerName">{{ item.task_number }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <img src="@/assets/images/icons/icon_2.png" alt="">
                                                <span>工程名称：{{ item.project_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_3.png" alt="">
                                                <span>客户名称：{{ item.customer_name }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_7.png" alt="">
                                                <span>用料时间：{{ item.arrival_time }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                                <span>施工部位：{{ item.place_detail }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                                <span>产品标号：{{ item.mark_num }}</span>
                                            </p>
                                            <p>
                                                <img src="@/assets/images/icons/icon_30.png" alt="">
                                                <span>任务放量：{{ item.quantity }}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="btns">
                                        <div @click="approval_see('sp', item, index)" v-if="listType == 'db'">
                                            <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                            审批
                                        </div>
                                        <div @click="approval_see('ck', item)">
                                            <img src="@/assets/images/icons/icon_gy_1.png" alt="">
                                            查看
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </v-touch>
    </div>
</template>
<script>
export default {
    name: 'matching-approval',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'matching-approval');
        }
        next();
    },
    data() {
        return {
            // 当前打开列表类型，db待办，yb已办
            listType: 'db',
            // 搜索条件
            value: '',
            // 下拉login状态
            isLoading: false,
            // 上拉login状态
            isUpLoading: false,
            // 是否加载完数据
            finished: false,
            // 上拉索引
            count: 0,
            // 列表数据
            listData: [],
            // 列表总条数
            total: 0,
        };
    },
    created() {},
    mounted() { },
    activated() {
        // 审批完成刷新列表
        if (this.$route.params.isSentSuccessfully) {
            this.onRefresh();
        }
    },
    update() { },
    beforeRouteUpdate() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 下拉刷新/搜索
        onRefresh() {
            this.count = 1;
            this.listData = [];
            this.finished = true;
            this.getInit();
        },
        // 上拉加载更多
        onLoad() {
            this.count++;
            this.getInit();
        },
        // 待办已办切换
        listSwitch(obj) {
            this.count = 1;
            this.listData = [];
            this.listType = obj;
            this.finished = false;
            this.getInit();
        },
        // 配比审批/查看
        approval_see(type, row, index) {
            let isReadOnly = false;
            if (type === 'ck') {
                isReadOnly = true;
            }
            this.$router.isBack = 2;
            this.$router.push({
                name: 'matchingApprovalView',
                params: {
                    isReadOnly: isReadOnly,
                    data: row,
                    listIndex: index,
                },
            });
        },
        // 获取关联配比列表数据
        getInit() {
            let requstUrl = '';
            if (this.listType === 'db') {
                requstUrl = '/productformula/formula_approval/pending';
            } else {
                requstUrl = '/productformula/formula_approval/examined';
            }
            this.$axios
                .get(`/interfaceApi/production${requstUrl}?searchValue=${this.value}&pageindex=${this.count}&pagesize=3`)
                .then(res => {
                    this.total = res.total;
                    if (res.rows) {
                        if (this.listData.length < 1) {
                            this.listData = res.rows;
                            this.finished = false;
                        } else {
                            this.listData.push(...res.rows);
                        }
                    }
                    if (this.listData.length === this.total) {
                        this.finished = true;
                    }
                    this.isLoading = false;
                    this.isUpLoading = false;
                })
                .catch(error => {
                    this.isLoading = false;
                    this.isUpLoading = false;
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
    },
    filter: {},
    computed: {},
    watch: {},
};
</script>

<style lang="stylus">
.matchingApproval
    height 100%
    .wrapper
        height 100%
        .van-nav-bar
            .van-nav-bar__title
                div
                    display inline-block
                    padding 0 15rpx
                    font-size 14rpx
                    color rgba(240,240,240,0.7)
                    transition 0.2s
                    &.active
                        font-size 18rpx
                        color #fff
        .iconshaixuan1
            font-size 20rpx
            color #ffffff
            margin-right 10rpx
        section
            height calc(100% - 45rpx)
            .van-pull-refresh
                height calc(100% - 45rpx)
                overflow: scroll;
                -webkit-overflow-scrolling: touch;
                .list
                    height calc(100% - 45rpx)
                    overflow-y auto
                    background #F0F0F0
                    padding 0 15rpx
                    padding-bottom 0
                    li
                        width 100%
                        background #fff
                        overflow hidden
                        margin-bottom 15rpx
                        position relative
                        padding 15rpx
                        position relative
                        &:first-child
                            margin-top 15rpx
                        strong
                            width 50rpx
                            height 25rpx
                            border-radius 4px
                            font-size 12rpx
                            line-height 23rpx
                            text-align center
                            color #FF6600
                            position absolute
                            top 12rpx
                            right 30rpx
                        .engineeringInfo
                            img,span
                                float left
                                height 16rpx
                                line-height 16rpx
                            img
                                width 16rpx
                                margin-right 12rpx
                            h4,p
                                overflow hidden
                            h4
                                margin-bottom 14rpx
                                span
                                    font-size 18rpx
                                    height 20rpx
                                    line-height 20rpx
                                    color #061F3E
                                    &:before
                                        font-size 20rpx
                                        margin-right 10rpx
                                        color #FF6600
                            p
                                margin-bottom 14rpx
                                span
                                    display inline-block
                                    width calc(100% - 40rpx)
                                    overflow hidden
                                    text-overflow ellipsis
                                    white-space nowrap
                                    font-size 14rpx
                                    color #666666
                            .state
                                position absolute
                                top 0
                                right 0
                                font-weight 400
                                width 40rpx
                                height 40rpx
                                &:before
                                    font-size 40rpx
                                    line-height 40rpx
                                    color #FF6600
                                    position absolute
                                    top 0px
                                    right 0
                                i
                                    position absolute
                                    width 40rpx
                                    text-align center
                                    font-size 10rpx
                                    color #FFFFFF
                                    transform rotate(45deg)
                                    top 7rpx
                                    left 7rpx

                            .telephone
                                width 25rpx
                                height 25rpx
                                background url(./../../../assets/images/clueManagement/phone@2x.png)
                                background-size 100% 100%
                                border none
                                position absolute
                                right 15rpx
                                bottom 25rpx
                        .btns
                            padding 0 6rpx
                            display flex
                            justify-content center
                            div
                                border 1px solid #D7D7D7
                                border-radius 4rpx
                                background #fff
                                height 32rpx
                                line-height 30rpx
                                text-align center
                                margin 0 25rpx
                                font-size 14rpx
                                color #333333
                                width calc((100% - 60rpx)/2)
                                img
                                    width 16rpx
                                    vertical-align middle
                                    margin-top -4rpx
                        &.Associated
                            h4
                                span
                                    &:before
                                        color #FF6600
                            .state
                                &:before
                                    color #FF6600
                        &.Uncorrelated
                            h4
                                span
                                    &:before
                                        color #979EA7
                            .state
                                &:before
                                    color #979EA7
</style>
